/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function BriefingView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '1440px',
        margin: '0 auto',
        padding: '24px 12px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
        {' '}
        <div> </div> <div style={{ flex: '1' }}></div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '7px' }}>
          <span style={{ fontSize: '13px', fontWeight: '500' }}>Watchlist</span>
          <span style={{ fontSize: '10.5px', color: 'var(--faint)' }}>(5/8)</span>
        </div>{' '}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
          {' '}
          {(m.wlChips ?? []).map((w, i28) => (
            <Fragment key={i28}>
              {' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '11.5px',
                  fontWeight: '500',
                  padding: '5px 7px 5px 12px',
                  borderRadius: '99px',
                  border: '1px solid var(--l12)',
                  background: 'var(--surface)',
                }}
              >
                {dc.t(w?.sym)}
                <button
                  className="scp-e8a2319"
                  onClick={w?.remove}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--faint)',
                    cursor: 'pointer',
                    padding: '0',
                    display: 'flex',
                  }}
                  aria-label={'Remove ' + dc.s(w.sym ?? w.label ?? w.name ?? '')}
                >
                  <i className="ph ph-x" style={{ fontSize: '10px' }}></i>
                </button>
              </span>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ display: 'flex', gap: '8px', marginTop: '12px', alignItems: 'center' }}>
          {' '}
          <input
            placeholder="e.g. XAUUSD"
            value={dc.v(m.wlInput)}
            onChange={m.setWlInput}
            style={{
              width: '220px',
              padding: '7px 12px',
              borderRadius: '8px',
              border: '1px solid var(--l10)',
              background: 'var(--fill)',
              color: 'var(--text)',
              fontSize: '12px',
              outline: 'none',
            }}
            aria-label="e.g. XAUUSD"
          />{' '}
          <button
            className="scp-2223d55"
            onClick={m.wlAdd}
            style={{
              fontSize: '11.5px',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid var(--l14)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            Add
          </button>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '13px', fontWeight: '500' }}>Briefing</span>
          <span style={{ fontSize: '10px', color: 'var(--faint)' }}>Generated 06:58 · London pre-open</span>
          <div style={{ flex: '1' }}></div>
          <span
            style={{
              fontSize: '9.5px',
              letterSpacing: '0.1em',
              fontWeight: '600',
              padding: '3px 9px',
              borderRadius: '99px',
              border: '1px solid var(--l8)',
              color: 'var(--acc-2)',
            }}
          >
            DAY VIEW
          </span>
        </div>{' '}
        <div
          style={{
            height: '1px',
            margin: '12px 0',
            background:
              'linear-gradient(90deg,transparent,var(--l10) 48px,var(--l10) calc(100% - 48px),transparent)',
          }}
        ></div>{' '}
        <div style={{ fontSize: '12.5px', lineHeight: '1.65', color: 'var(--text2)', maxWidth: '78ch' }}>
          Risk tone is constructive into the London open. The dollar is on the back foot after yesterday's ECB
          hold, gold is consolidating a three-day advance near $4,035, and the macro window is clear until US
          jobless claims at 08:30 ET. Your best expressions today are long gold on dips into H1 demand and
          long EUR/USD on trendline retests — keep JPY exposure light ahead of Tokyo CPI tonight.
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))',
            gap: '10px',
            marginTop: '16px',
          }}
        >
          {' '}
          <div style={{ border: '1px solid var(--l8)', borderRadius: '10px', padding: '13px 15px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '12.5px', fontWeight: '600' }}>XAUUSD</span>
              <span
                style={{
                  fontSize: '9.5px',
                  fontWeight: '600',
                  letterSpacing: '0.06em',
                  padding: '2px 8px',
                  borderRadius: '99px',
                  background: 'color-mix(in srgb, var(--pos) 12%, transparent)',
                  color: 'var(--pos)',
                }}
              >
                BULLISH
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '11px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                4,034.92
              </span>
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', lineHeight: '1.6', marginTop: '7px' }}>
              Holding above reclaimed 4,028 shelf. Buy-side liquidity resting at 4,058; invalidation below
              4,022.
            </div>{' '}
          </div>{' '}
          <div style={{ border: '1px solid var(--l8)', borderRadius: '10px', padding: '13px 15px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '12.5px', fontWeight: '600' }}>EURUSD</span>
              <span
                style={{
                  fontSize: '9.5px',
                  fontWeight: '600',
                  letterSpacing: '0.06em',
                  padding: '2px 8px',
                  borderRadius: '99px',
                  background: 'color-mix(in srgb, var(--pos) 12%, transparent)',
                  color: 'var(--pos)',
                }}
              >
                BULLISH
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '11px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                1.13761
              </span>
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', lineHeight: '1.6', marginTop: '7px' }}>
              Post-ECB drift higher. Broken H4 trendline retest at 1.1355 is the level to lean on; target
              1.1420.
            </div>{' '}
          </div>{' '}
          <div style={{ border: '1px solid var(--l8)', borderRadius: '10px', padding: '13px 15px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '12.5px', fontWeight: '600' }}>USDJPY</span>
              <span
                style={{
                  fontSize: '9.5px',
                  fontWeight: '600',
                  letterSpacing: '0.06em',
                  padding: '2px 8px',
                  borderRadius: '99px',
                  background: 'color-mix(in srgb, var(--neg-fill) 14%, transparent)',
                  color: 'var(--neg)',
                }}
              >
                BEARISH
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '11px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                163.791
              </span>
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', lineHeight: '1.6', marginTop: '7px' }}>
              Lower high under the 164.00 weekly supply. Tokyo CPI tonight is the catalyst risk — size down.
            </div>{' '}
          </div>{' '}
          <div style={{ border: '1px solid var(--l8)', borderRadius: '10px', padding: '13px 15px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '12.5px', fontWeight: '600' }}>GBPUSD</span>
              <span
                style={{
                  fontSize: '9.5px',
                  fontWeight: '600',
                  letterSpacing: '0.06em',
                  padding: '2px 8px',
                  borderRadius: '99px',
                  background: 'var(--l8)',
                  color: 'var(--muted)',
                }}
              >
                NEUTRAL
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '11px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                1.33257
              </span>
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', lineHeight: '1.6', marginTop: '7px' }}>
              Rangebound 1.3290–1.3340. No edge until flash PMIs; stand aside.
            </div>{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(420px,1fr))',
          gap: '12px',
          alignItems: 'start',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="ph ph-newspaper" style={{ color: 'var(--muted)', fontSize: '15px' }}></i>
            <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Live News</span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted2)',
              }}
            >
              3 stories
            </span>
            <div style={{ flex: '1' }}></div>
            <i className="ph ph-caret-up" style={{ color: 'var(--faint)', fontSize: '12px' }}></i>
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '12px' }}>
            {' '}
            {(m.news ?? []).map((n, i29) => (
              <Fragment key={i29}>
                {' '}
                <div style={{ border: '1px solid var(--l8)', borderRadius: '11px', padding: '12px 14px' }}>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span
                      style={{
                        fontSize: '9.5px',
                        fontWeight: '600',
                        padding: '2px 8px',
                        borderRadius: '99px',
                        background: 'color-mix(in srgb, var(--acc-fill) 14%, transparent)',
                        color: 'var(--acc-2)',
                      }}
                    >
                      {dc.t(n?.src)}
                    </span>
                    <div style={{ flex: '1' }}></div>
                    <span style={{ fontSize: '10px', color: 'var(--faint)' }}>
                      <i className="ph ph-clock" style={{ fontSize: '10px' }}></i> {dc.t(n?.when)}
                    </span>
                  </div>{' '}
                  <div style={{ fontSize: '12px', fontWeight: '500', lineHeight: '1.45', marginTop: '7px' }}>
                    {dc.t(n?.title)}
                  </div>{' '}
                  <div
                    style={{ fontSize: '11px', color: 'var(--muted2)', lineHeight: '1.55', marginTop: '4px' }}
                  >
                    {dc.t(n?.body)}
                  </div>{' '}
                  <a
                    href="#"
                    aria-disabled="true"
                    aria-describedby="pf-brief-article-note"
                    onClick={(e) => e.preventDefault()}
                    style={{
                      fontSize: '10.5px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px',
                      marginTop: '7px',
                    }}
                  >
                    {'Read full article '}
                    <i className="ph ph-arrow-square-out" style={{ fontSize: '10px' }}></i>
                  </a>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
            alignSelf: 'start',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="ph ph-calendar-blank" style={{ color: 'var(--muted)', fontSize: '15px' }}></i>
            <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Next 24h Macro Calendar</span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted2)',
              }}
            >
              4
            </span>
            <div style={{ flex: '1' }}></div>
            <i className="ph ph-caret-up" style={{ color: 'var(--faint)', fontSize: '12px' }}></i>
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '8px' }}>
            {' '}
            {(m.calendar ?? []).map((e, i30) => (
              <Fragment key={i30}>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '10px 4px',
                    borderBottom: '1px solid var(--l5)',
                  }}
                >
                  {' '}
                  <span
                    style={{
                      fontSize: '11.5px',
                      color: 'var(--muted)',
                      fontVariantNumeric: 'tabular-nums',
                      width: '40px',
                    }}
                  >
                    {dc.t(e?.time)}
                  </span>{' '}
                  <span
                    style={{
                      fontSize: '10px',
                      fontWeight: '600',
                      letterSpacing: '0.05em',
                      padding: '2px 7px',
                      borderRadius: '6px',
                      background: 'var(--l6)',
                      color: 'var(--text-mid)',
                    }}
                  >
                    {dc.t(e?.ccy)}
                  </span>{' '}
                  <span style={{ fontSize: '12px', flex: '1' }}>{dc.t(e?.event)}</span>{' '}
                  <span style={dc.css(`font-size:10px;font-weight:500;color:${dc.s(e?.fg)}`)}>
                    {dc.t(e?.impact)}
                  </span>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>
      <span hidden id="pf-brief-article-note">
        The brief is simulated — there is no external article to open until a news provider is bound
        (ESC-006).
      </span>
    </div>
  );
}
